import { render, staticRenderFns } from "./EditClientListItem.vue?vue&type=template&id=08334550"
import script from "./EditClientListItem.vue?vue&type=script&lang=ts"
export * from "./EditClientListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports